import { FC, MouseEvent, useState } from 'react';
import sprite from '../../../../../../assets/images/sprite.svg';
import { StyledLink } from '../../AssortmentList/ListItem/ListItem.styled';
import { Menu } from '@mui/material';
import { BatteriesList } from '../BatteriesList/BatteriesList';
import { BatteryButton } from './DesktopBatteries.styled';

export const DesktopBatteries: FC = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (e: MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

    const handleSubMenuClick = (newOpen: boolean) => {
    setAnchorEl(newOpen ? anchorEl : null);
  };

  return (
    <>
      <StyledLink to="/batteries">Елементи</StyledLink>
      <BatteryButton
        handleOpen={anchorEl}
        type="button"
        aria-owns={open ? 'desktop-sub-menu' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        onMouseOver={handleClick}
      >
        <svg>
          <use href={`${sprite}#arrow-left`}></use>
        </svg>
      </BatteryButton>

      <Menu
        id="desktop-sub-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        MenuListProps={{ onMouseLeave: handleClose, disablePadding: true }}
        aria-expanded={open ? 'true' : undefined}
        sx={{
          '& .MuiMenu-paper': {
            bgcolor: 'background.paper',
            width: '200px',
            p: '10px',
            borderRadius: '20px',
            boxShadow: '0 12px 32px rgba(23, 26, 29, 0.14)',
          },
        }}
      >
        <BatteriesList handleClick={handleSubMenuClick}/>
      </Menu>
    </>
  );
};
